import { useState, useEffect } from 'react';
import { collection, query, where, getDocs } from 'firebase/firestore';
import { db } from '../firebase';
import { useOrg } from './useOrg';

/**
 * @param {string} [organizationIdOverride] - When set (e.g. CAPA from parent), uses this org instead of OrgContext.
 */
export function useOrgUsers(organizationIdOverride) {
  const { activeOrgId } = useOrg();
  const orgId = organizationIdOverride ?? activeOrgId;
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!orgId) return;
    setLoading(true);
    const q = query(
      collection(db, 'users'),
      where('organizationId', '==', orgId)
    );
    getDocs(q)
      .then(snap => {
        setUsers(snap.docs.map(d => ({
          userId: d.id,
          fullName: d.data().full_name || d.data().displayName || d.data().email || d.id,
          email: d.data().email || '',
          roleId: d.data().role_id || ''
        })));
      })
      .catch(err => console.warn('[useOrgUsers]', err))
      .finally(() => setLoading(false));
  }, [orgId]);

  return { users, loading };
}
